<div
    class="relative grow overflow-y-auto"
    [ngClass]="{ 'blur-[2px] pointer-events-none [&_*]:select-none': saving() }"
>
    @if (saving()) {
        <div
            class="absolute flex left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 justify-center items-center z-50"
        >
            <mat-spinner [diameter]="32"></mat-spinner>
        </div>
    }

    <div class="flex flex-col gap-4 bg-valamargray border-2 static p-4">
        <button class="flex valben-button text-lg ml-auto" (click)="save()">Spremi</button>

        <valben-dictionary-input
            [formField]="surveyForm.names"
            title="Naziv"
        ></valben-dictionary-input>

        <valben-dictionary-input
            [formField]="surveyForm.descriptions"
            [textArea]="true"
            [richText]="true"
            title="Opis"
        ></valben-dictionary-input>

        <valben-boolean-input
            [formField]="surveyForm.isActive"
            title="Aktivan"
        ></valben-boolean-input>

        <valben-file-input
            [formField]="surveyForm.image"
            title="Prenesi sliku ili direktni url postojeće slike"
            fileType="image/*"
        ></valben-file-input>

        <valben-text-input [formField]="surveyForm.link" title="Link"></valben-text-input>

        <valben-date-range-picker
            [startField]="surveyForm.startDate"
            [endField]="surveyForm.endDate"
            [minDate]="tomorrow"
            [showTodayButton]="false"
        ></valben-date-range-picker>

        <valben-filters [(value)]="filters" />

        <div class="flex gap-4 justify-end items-center select-none">
            <button class="valben-button text-lg" (click)="back()">Natrag</button>
            <button class="text-lg valben-button" (click)="draft()">Skica</button>
            <button class="text-lg valben-button" (click)="save()">Spremi</button>
        </div>
    </div>
</div>
